import { Service } from '@/tools'
export class contractCostExpenseService<T extends TContract.CostExpense> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TContract.CostExpense}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 成本费用管理分页查询--/api/contract/costExpense/v1/pageCostExpenseList
  pageWarnSetList = <K extends T['ApiPageCostExpenseList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPageCostExpenseList', data)
  // 成本费用管理新增--/api/contract/costExpense/v1/add
  add = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAdd', data)
  // 成本费用管理编辑--/api/contract/costExpense/v1/update
  update = <K extends T['ApiUpdate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdate', data)
  // 成本费用管理删除--/api/contract/costExpense/v1/delete
  delete = <K extends T['ApiDelete']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDelete', data)
}
